/* eslint-disable import/prefer-default-export */
import Styled from 'styled-components';

export const Wrapper = Styled.span`
  position: absolute;
  top: 16px;
  left: 20px;
  padding: 8px 32px;
  cursor: pointer;
  z-index: 99;
  text-decoration: none;
  color: #fff;
  line-height: 1;
  font-family: Exo BNNVARA, Exo, Verdana, sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
  white-space: nowrap;
  width: max-content;
  background-color: #cd0000;
  animation: slideIn 24s forwards;

  @keyframes slideIn {  
  from {  
      left: -80%;
  }  
  5%, 95% {  
      left: 20px;
  }  
  to {
    left: -80%;
  }
} 
`;
